<template>
  <button class="site-search-btn" @click="openSearchMenu">
    <svg-magnify-glass class="site-search-btn__icon"></svg-magnify-glass>
    Search
  </button>
</template>

<script>

export default {
  
	data() {
		return {
		}
	},

	methods: {
		openSearchMenu() {
			this.emitter.emit('site:search');
		},
	}
}

</script>
